/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import type {
  GetMyIdentityConfirmationQueryResponse,
  GetMyIdentityConfirmation401,
  GetMyIdentityConfirmation502,
  GetMyIdentityConfirmation503,
} from '../types/GetMyIdentityConfirmation.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { getMyIdentityConfirmation } from '../clients/getMyIdentityConfirmation.ts';

export const getMyIdentityConfirmationQueryKey = () =>
  [{ url: '/me/identity-confirmation' }] as const;

export type GetMyIdentityConfirmationQueryKey = ReturnType<
  typeof getMyIdentityConfirmationQueryKey
>;

export function getMyIdentityConfirmationQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getMyIdentityConfirmationQueryKey();
  return queryOptions<
    GetMyIdentityConfirmationQueryResponse,
    ResponseErrorConfig<
      GetMyIdentityConfirmation401 | GetMyIdentityConfirmation502 | GetMyIdentityConfirmation503
    >,
    GetMyIdentityConfirmationQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getMyIdentityConfirmation({ ...config, signal: config.signal ?? signal });
    },
  });
}

/**
 * {@link /me/identity-confirmation}
 */
export function useGetMyIdentityConfirmation<
  TData = GetMyIdentityConfirmationQueryResponse,
  TQueryData = GetMyIdentityConfirmationQueryResponse,
  TQueryKey extends QueryKey = GetMyIdentityConfirmationQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetMyIdentityConfirmationQueryResponse,
        ResponseErrorConfig<
          GetMyIdentityConfirmation401 | GetMyIdentityConfirmation502 | GetMyIdentityConfirmation503
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey = resolvedOptions?.queryKey ?? getMyIdentityConfirmationQueryKey();

  const query = useQuery(
    {
      ...getMyIdentityConfirmationQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetMyIdentityConfirmation401 | GetMyIdentityConfirmation502 | GetMyIdentityConfirmation503
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
